var _defs, _g, _script;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 112 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e62058;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    className: "cls-1",
    d: "M27.65,14.37H9.55c-4.97-.02-9.04,3.93-9.17,8.9,0,.13,.1,.24,.24,.24H18.72c4.97,.02,9.04-3.94,9.17-8.91,0-.13-.11-.24-.24-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    className: "cls-1",
    d: "M36.82,.63H9.55C4.58,.61,.51,4.57,.39,9.54c0,.13,.1,.24,.23,.24H27.9c4.97,.02,9.04-3.94,9.17-8.91,0-.13-.11-.24-.24-.24h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    className: "cls-1",
    cx: 4.97,
    cy: 32.62,
    r: 4.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1591",
    className: "cls-1",
    x: 56.59,
    y: 6.21,
    width: 4.45,
    height: 24.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    className: "cls-1",
    d: "M110.93,22.61c0-4.62-3.25-8.49-7.84-8.49-4.93,0-8.08,4.04-8.08,8.66-.18,4.58,3.38,8.44,7.96,8.63,.24,0,.49,0,.73,0,2.59,.03,5.07-1.05,6.81-2.98l-2.53-2.53c-1.07,1.18-2.58,1.87-4.17,1.92-2.3,.08-4.26-1.65-4.48-3.94h11.5c.07-.42,.1-.84,.1-1.27Zm-11.4-1.98c.33-1.7,1.83-2.92,3.56-2.91,1.67,0,3.08,1.25,3.29,2.91h-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    className: "cls-1",
    d: "M76.61,16.03l-.32-.26c-1.37-1.11-3.09-1.7-4.85-1.67-4.57,0-8.15,3.81-8.15,8.67-.01,2.14,.74,4.21,2.13,5.83,1.59,1.79,3.87,2.82,6.27,2.81,1.69,.02,3.33-.57,4.61-1.67l.32-.27v1.59h4V14.45h-4v1.58Zm-4.62,11.86c-2.74-.07-4.9-2.34-4.84-5.08-.06-2.74,2.1-5.01,4.84-5.08,2.74,.07,4.9,2.34,4.84,5.08,.06,2.74-2.1,5.01-4.84,5.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    className: "cls-1",
    d: "M92.21,14.1c-1.76-.02-3.48,.57-4.85,1.67l-.32,.26v-1.58h-4V31.06h3.99v-8.66c-.01-1.34,.55-2.62,1.55-3.51,.85-.75,1.94-1.16,3.08-1.16,.75,0,1.49,.18,2.15,.53l1.32-3.6c-.93-.37-1.92-.56-2.93-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    className: "cls-1",
    d: "M49.71,10.89h0c.7-.75,1.69-1.13,2.71-1.06,.41,0,.81,.05,1.21,.13l.63-3.52c-.81-.19-1.64-.28-2.48-.27-1.91-.05-3.76,.65-5.16,1.94-1.22,1.19-1.77,2.85-1.77,5.4v.89h-3.06v3.47h3.06v13.15h4.17v-13.15h4.74v-3.47h-4.74v-.72c-.12-.99,.12-1.99,.68-2.82Z"
  }))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    type: "application/javascript"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlare);
export default __webpack_public_path__ + "static/media/flare.73f59ddd27cff1320d00bb7020978377.svg";
export { ForwardRef as ReactComponent };